import { Directive, Input,OnChanges } from '@angular/core';
import {NG_VALIDATORS,Validator, AbstractControl} from '@angular/forms';

@Directive({
    selector: '[greaterThan]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: GreaterThanValidator,
        multi: true
    }]
})
export class GreaterThanValidator implements Validator ,OnChanges{
    @Input('otherControl') otherControl: AbstractControl;

    validate(control: AbstractControl): { [key: string]: any; } {
        return control.value > this.otherControl.value ? null : {'greaterThan' : true};
    }

    ngOnChanges(){
        this.otherControl.valueChanges.subscribe(() =>{
            if(this._onChange) this._onChange();
        });
    }
    
    private _onChange: () => void;

    registerOnValidatorChange(fn: () => void): void { 
        this._onChange = fn; 
    }
}